<template>
  <tbody>
  <template v-for="(item, index) in list">
    <row-tr
        :flag="flag"
        :headers="headers"
        :key="getUniqKey(item.trip_id)"
        :line="item"
        :isRefreshCheckbox="isRefreshCheckbox"
        :checkAll="checkAll"
        :filterClasses="filterClasses"
        :isRefresh="isRefresh"
        :isCloseChildren="isCloseChildren"
        :isIndexNumber="isIndexNumber"
        :indexNumber="getIndexNumber(index)"
        :department_id="department_id"
        @updateChild="onChild"
        @updateEdit="onEdit"
        @updateClickButton="onClickButton"
        @updateModEvent="onModEvent"
        @updateCheckOrder="onCheckOrder"
        @updatePaid="onPaid"
        @updateCounter="onCounter"
    ></row-tr>
    <template v-if="item.children">
      <row-tr
          v-for="child in item.children"
          @updateChild="onChild"
          @updateEdit="onEdit"
          @updateClickButton="onClickButton"
          @updateModEvent="onModEvent"
          :key="child.load_id"
          :flag="flag"
          :headers="headersChildren"
          :line="child"
          :filterClasses="filterClasses"
          isChildren
          :isRefresh="isRefresh"
          :isCloseChildren="isCloseChildren"
          :isIndexNumber="isIndexNumber"
          :indexNumber="getIndexNumber(index)"
          :department_id="department_id"
          isChild
      ></row-tr>
    </template>
  </template>
  </tbody>
</template>

<script>
// components
import RowTr from "@/shared/MainTable/RowTr/RowTr";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Tbody",
	components: {
		RowTr,
	},
	props: {
		flag: String,
		headers: Array,
		department_id: Number,
		isRefreshCheckbox: String,
		checkAll: Boolean,
		headersChildren: Array,
		list: Array,
		isRefresh: String,
		filterClasses: Object,
		isCloseChildren: String,
		isIndexNumber: Boolean,
		page: Number,
		limit: Number,
	},
	data() {
		return {
			limitModData: null,
		};
	},
	methods: {
		getUniqKey(id) {
			return id + getUniqId();
		},
		onCounter(values) {
			this.$emit('updateCounter', values);
		},
		getIndexNumber(value) {
			const limitModData = this.limit * this.page;
			const index = value + 1;

			return (limitModData - this.limit) + index;
		},
		onCheckOrder(id, line) {
			this.$emit('updateCheckOrder', { id, line });
		},
		onEdit(value) {
			this.$emit("updateEdit", value);
		},
		onChild(value) {
			this.$emit("updateChild", value);
		},
		onClickButton(values) {
			this.$emit("updateClickButton", values);
		},
		onModEvent(args) {
			this.$emit('updateModEvent', args);
		},
		onPaid(values) {
			this.$emit('updatePaid', values);
		}
	},
};
</script>

